import { addMutator } from '@poa/state';
import {
  changeGrouping,
  fetchGifts,
  fetchGiftsFailed,
  fetchGiftsSuccess,
  resetGrouping,
  changeFilter
} from './gifts.actions';

// fetch
addMutator(fetchGifts, (payload, { store }) => {
  store.gifts.meta.isLoading = true;
  store.gifts.meta.hasError = false;
});

addMutator(fetchGiftsSuccess, (response, { store }) => {
  store.gifts.meta.isLoading = false;
  store.gifts.meta.hasError = false;

  store.gifts.data.replace([response.data.data.data]);

  store.gifts.meta.loaded = true;
});

addMutator(fetchGiftsFailed, (payload, { store }) => {
  store.gifts.meta.isLoading = false;
  store.gifts.meta.hasError = true;
});

addMutator(changeFilter, ({ filter }, { store }) => {
  store.gifts.filters.filter = filter;
});

// grouping
addMutator(changeGrouping, ({ grouping }, { store }) => {
  store.gifts.filters.grouping.selected = grouping;
});

addMutator(resetGrouping, ({ grouping }, { store }) => {
  store.gifts.filters.grouping = grouping;
});
